import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { DashboardComponent } from './shared/dashboard/dashboard.component';
import { environment } from '../environments/environment';
import { SampleApplicationComponent } from './sample-application/sample-application.component';
import { DashboardGuard } from './shared/dashboard/dashboard.guard';
import { ExtranetModule } from './shared/modules-access/extranet-module.enum';
import { ModuleGuard } from './shared/modules-access/module.guard';
import { NoAccessPageComponent } from './shared/dashboard/no-access-page/no-access-page.component';
import { ChangePasswordPageComponent } from './change-password-page/change-password-page.component';
import { activeLanguageKey } from './shared/dashboard/change-language/change-language.component';
import { TokenBaselinkerPageComponent } from './token-baselinker-page/token-baselinker-page.component';
import { DummyRedirectComponent } from './dummy-redirect-component';

export let routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: '',
        canActivate: [ModuleGuard],
        component: DummyRedirectComponent
      },
      {
        path: 'password',
        component: ChangePasswordPageComponent,
        canActivate: [ModuleGuard],
        data: {
          moduleType: ExtranetModule.All
        },
      },
      {
        path: 'shipment/baselinker-token',
        component: TokenBaselinkerPageComponent,
        canActivate: [ModuleGuard],
        data: {
          moduleType: ExtranetModule.All
        },
      },
      {
        path: 'shipment',
        loadChildren: () =>
          import('@kns-jasfbg/feature-shipment').then(
            module => module.FeatureShipmentModule
          ),
        data: {
          shipmentApiUrl: environment.shipmentApiUrl,
          consentApiUrl: environment.gatewayUrl,
          changePasswordUrl: environment.authConfig.issuer + '/Manage/ChangePassword',
          language: localStorage.getItem(activeLanguageKey) || 'pl',
          moduleType: ExtranetModule.Shipment
        },
        canActivate: [ModuleGuard]
      },

      {
        path: 'agencies',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-agencies').then(
            (module) => module.FeatureAgenciesModule
          ),
        data: {
          agenciesApiUrl: environment.agenciesApiUrl,
          moduleType: ExtranetModule.Agencies
        },
        canActivate: [ModuleGuard]
      },

      {
        path: 'settlements',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-settlements').then(
            (module) => module.FeatureSettlementsModule
          ),
        data: {
          settlementsApiUrl: environment.settlementsApiUrl,
          moduleType: ExtranetModule.Settlements
        },
        canActivate: [ModuleGuard]
      },

      {
        path: 'logistics',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-logistics').then(
            (module) => module.FeatureLogisticsModule
          ),
        data: {
          logisticsDocumentsApiUrl: environment.logisticsDocumentsApiUrl,
          moduleType: ExtranetModule.Logistics
        },
        canActivate: [ModuleGuard]
      },

      {
        path: 'sample-application',
        component: SampleApplicationComponent,
        data: {
          moduleType: ExtranetModule.SampleApplication
        },
        canActivate: [ModuleGuard]
      },
      {
        path: 'no-access',
        component: NoAccessPageComponent
      },

      {
        path: 'admin-panel',
        loadChildren: () =>
          import('@kns-jasfbg/users').then(
            (module) => module.UsersLibExtranetModule
          ),
        data: {
          extranetGatewayUrl: environment.gatewayUrl,
          consentsApiUrl: environment.gatewayUrl,
          moduleType: ExtranetModule.Users
        },
        canActivate: [ModuleGuard]
      },
      {
        path: 'archive',
        loadChildren: () =>
          import('@kns-jasfbg/notifications').then(
            (module) => module.NotificationsLibExtranetModule
          ),
        data: {
          extranetGatewayUrl: environment.gatewayUrl,
          consentsApiUrl: environment.gatewayUrl,
          moduleType: ExtranetModule.All
        },
        canActivate: [ModuleGuard]
      }
    ],
    canActivate: [DashboardGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
